import React, { useEffect } from "react";
import { Container, Row, Nav } from "react-bootstrap";
import { FaArchive, FaHeadset, FaHome, FaPlus } from "react-icons/fa";
import { NavLink, useNavigate } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { isSubscribedAccountant } from "../../utils";

const IndexStrategicgoals = () => {
  const settings = {
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    // centerMode: true,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: false,

        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false

        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false

        }
      }
    ]
  };

  const navigate = useNavigate()
  useEffect(() => {
    if (!isSubscribedAccountant()) {
      navigate("/users/billings");
      window.location.reload();
    }
  }, []);
  
  return (
    <Container fluid>
      <Row className="m-1">
        <Slider {...settings}>
          <div className="slider-item">
            <Nav variant="pills" className="border-tab nav-primary">
              <Nav.Item>
                <Nav.Link as={NavLink} to="/Strategic-goal/ninty-days-sprints" exact>
                  <FaHome className="me-1" />
                  90-Day Sprint
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </div>
          <div className="slider-item">
            <Nav variant="pills" className="border-tab nav-primary">
              <Nav.Item>
                <Nav.Link as={NavLink} exact to="/Strategic-goal/one-year-goal">
                  <FaPlus className="me-1" />
                  1-Year Goals
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </div>
          <div className="slider-item">
            <Nav variant="pills" className="border-tab nav-primary">
              <Nav.Item>
                <Nav.Link as={NavLink} exact to="/Strategic-goal/years-aspirations">
                  <FaHeadset  className="me-1" />
                  10-25 Year Strategic Aspirations
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </div>
          <div className="slider-item">
            <Nav variant="pills" className="border-tab nav-primary">
              <Nav.Item>
                <Nav.Link as={NavLink} exact to="/Strategic-goal/parking-lot-items">
                  <FaArchive className="me-1" />
                  Parking Lot Items
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </div>

        </Slider>
      </Row>
    </Container>
  );
};

export default IndexStrategicgoals;
